import React from "react";
import Payment from "components/payment/Payment";
import PaymentActionBar from "components/payment/PaymentActionBar";
import "./payment.scss";
import { useTranslation } from "react-i18next";
const Payments = () => {
  const { t } = useTranslation();
  return (
    <div className="payment">
      <div className="custom-breadcrumbs ">
        <span className="breadcrumbs-item ">{t("payment")}</span>
      </div>

      <p>{t("total-monthly-income")}</p>
      <h3>€ 0</h3>
      <PaymentActionBar />
      <Payment />
    </div>
  );
};

export default Payments;
